import { profileImage } from "../../../assets/png";
import "../../../styles/side-navbar.scss";
import { Link, useLocation } from "react-router-dom";
import { useContext } from "react";
import TrainerContext from "../../../context/trainerContext/TrainerContext";
import { FaUsers } from "react-icons/fa";
import { isAccessAllowed } from "../../../utils/helpers";

function SideNavBar() {
  const location = useLocation();
  const currentRoute = location.pathname;
  const isViewSlotManagementAllowed = isAccessAllowed("MANAGE_TRAINER_SLOTS");
  const isViewSessionManagementAllowed = isAccessAllowed(
    "MANAGE_TRAINER_SESSIONS"
  );

  const { getTrainerState } = useContext(TrainerContext);
  const trainerData = getTrainerState();

  const sidenavbarButtons = [
    // { name: "Dashboard", icon: dashboardIcon, url: "dashboard" },
    // { name: "New task", icon: heartIcon, url: "newtask" },
    { name: "Users", icon: <FaUsers />, url: "/" },
    { name: "Your availability", icon: <FaUsers />, url: "/trainers/slots" },
    { name: "Your sessions", icon: <FaUsers />, url: "/trainers/sessions" },
  ].filter((item: any) => {
    if (item?.url === "/trainers/slots") {
      return isViewSlotManagementAllowed;
    }
    if (item?.url === "/trainers/sessions") {
      return isViewSessionManagementAllowed;
    }
    return true;
  });

  const adminSidebarOptions = [
    { name: "Users", icon: <FaUsers />, url: "/" },
    { name: "CGM Users", icon: <FaUsers />, url: "/admin/cgm-users" },
    { name: "Trainers", icon: <FaUsers />, url: "/admin/trainers" },
    { name: "Roles", icon: <FaUsers />, url: "/admin/roles" },
    { name: "Permissions", icon: <FaUsers />, url: "/admin/permissions" },
  ];

  const listToShow = trainerData?.trainerIsAdmin
    ? adminSidebarOptions
    : sidenavbarButtons;

  return (
    <div className="desktop-side-navbar">
      <div className="card-header-wrapper d-flex flex-column align-items-center py-3 text-center">
        <img src={trainerData?.trainerImage || profileImage} alt="profile" />
        <div className="user-profile mt-3">
          <h4 className="fs-20 fw-700 text-capitalize mb-0">
            {trainerData?.trainerName}
          </h4>
          <Link to="/profile" className="fs-14 fw-600">
            View profile
          </Link>
        </div>
      </div>

      <div className="sidemenu-items">
        {listToShow?.length > 0 &&
          listToShow?.map((item, index) => {
            const isActive =
              item?.url !== "/"
                ? currentRoute.startsWith(item?.url)
                : currentRoute?.startsWith("/users") ||
                  item?.url === currentRoute;
            return (
              <Link
                key={`sidebar-link-${index}`}
                to={item?.url}
                style={{
                  background: isActive
                    ? "linear-gradient(270deg, #EBFAF4 0%, rgba(235, 250, 244, 0) 100%)"
                    : "white",
                  color: isActive ? "#15c0b6" : "#B8B8B8",
                }}
                className="d-flex align-items-center p-3 gap-2"
              >
                <FaUsers size={18} />
                {item?.name}
              </Link>
            );
          })}
      </div>
    </div>
  );
}

export default SideNavBar;
